import { GiftCard } from './types/types';

export type ModalViews = 'receipt' | 'receiptConfirmation' | 'refund' | 'refundConfirmation';

type State = {
  codeInput: { error: string; value: string };
  ssnInput: { error: string; value: string };
  modalView: ModalViews | null;
  giftCard: GiftCard | null;
  loading: boolean;
  returnError: string | null;
  confirmLoading: boolean;
};

type Action =
  | { type: 'SET_CODE_ERROR'; payload: string }
  | { type: 'SET_CODE'; payload: string }
  | { type: 'SET_SSN'; payload: string }
  | { type: 'SET_SSN_ERROR'; payload: string }
  | { type: 'SET_MODAL_VIEW'; payload: ModalViews | null }
  | { type: 'SET_GIFTCARD'; payload: { giftcard: GiftCard | null; codeError: string | null } }
  | { type: 'SET_LOADING' }
  | { type: 'SET_RETURN_ERROR'; payload: string | null }
  | { type: 'SET_CONFIRM_LOADING' }
  | { type: 'RESET' };

export const giftCardReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'RESET':
      const hasResentReceipt = state.modalView === 'receiptConfirmation';
      return {
        ...state,
        modalView: null,
        confirmLoading: false,
        returnError: null,
        loading: false,
        ssnInput: { error: '', value: '' },
        ...(!hasResentReceipt ? { codeInput: { value: '', error: '' }, giftCard: null } : {}),
      };
    case 'SET_CODE_ERROR':
      return { ...state, codeInput: { ...state.codeInput, error: action.payload } };
    case 'SET_CODE':
      return {
        ...state,
        codeInput: { error: !action.payload ? '' : state.codeInput.error, value: action.payload },
        returnError: null,
      };
    case 'SET_SSN':
      return { ...state, ssnInput: { error: '', value: action.payload } };
    case 'SET_SSN_ERROR':
      return { ...state, ssnInput: { ...state.ssnInput, error: action.payload } };
    case 'SET_MODAL_VIEW':
      return { ...state, modalView: action.payload, confirmLoading: false };
    case 'SET_GIFTCARD':
      return {
        ...state,
        giftCard: action.payload.giftcard,
        codeInput: { ...state.codeInput, error: action.payload.codeError },
        returnError: null,
        loading: false,
      };
    case 'SET_LOADING':
      return { ...state, loading: true };
    case 'SET_RETURN_ERROR':
      return { ...state, returnError: action.payload, modalView: null, confirmLoading: false };
    case 'SET_CONFIRM_LOADING':
      return { ...state, confirmLoading: true };
    default:
      return state;
  }
};
